module.exports = __webpack_public_path__ + "img/manutd1.4704ae77.jpg";